import { BaseButtonStyledProps } from "../types";

export const getButtonMinWidth = ({ hasNoIcons, appearance }: BaseButtonStyledProps) => {
    switch (appearance) {
        // In Lodestar, Only non-borderless buttons with no icons have a min width
        case "borderless":
        case "link":
            // Undefined here means "don't set a min width".
            return undefined;
        case "primary":
        case "secondary":
        case "destructive":
        case "destructive-tertiary":
        case "secondary-destructive":
        case "share":
            if (hasNoIcons) {
                return "96px";
            } else {
                return undefined;
            }
        default:
            return undefined;
    }
};
